import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ContactHero from './components/ContactHero';
import DepartmentCardsSection from './components/DepartmentCardsSection';
import ContactFormSection from './components/ContactFormSection';
import OfficeLocationSection from './components/OfficeLocationSection';
import ContactCTABand from './components/ContactCTABand';

export default function ContactPage() {
  return (
    <>
      <Navbar />
      <main className="min-h-screen">
        <ContactHero />
        <DepartmentCardsSection />
        <ContactFormSection />
        <OfficeLocationSection />
        <ContactCTABand />
      </main>
      <Footer />
    </>
  );
}